// extracted by mini-css-extract-plugin
export default {"section":"tXmCi","activities":"_30jPC","empty-state":"_3MziB","emptyState":"_3MziB"};